import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, unref as _unref, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createSlots as _createSlots } from "vue"

const _hoisted_1 = { class: "add-to-list__list" }
const _hoisted_2 = { class: "add-to-list__controls" }

import { onBeforeUnmount, ref, watch } from 'vue'
import type { Raw } from 'vue'

import {
  isWantToRead,
  type DocCustomListsView,
} from '@/models/doc.custom.lists'

import BasePopup from '@/components/ui/BasePopup.vue'
import CircleSpinner from '@/components/ui/CircleSpinner.vue'
import LoadingError from '@/components/ui/LoadingError.vue'
import ToggleButton from '@/components/ui/ToggleButton.vue'
import CustomListForm from '../custom.lists/CustomListForm.vue'
import AppButton from '@/app/components/button/AppButton.vue'
import { CreateCustomListForm } from '@/models/custom.lists'


export default /*@__PURE__*/_defineComponent({
  __name: 'AddToListPopup',
  props: {
    view: {},
    newStyle20321B: { type: Boolean },
    anchor: {}
  },
  setup(__props: any, { expose: __expose }) {

const props = __props

const basePopup = ref<InstanceType<typeof BasePopup> | null>(null)
const customListForm = ref<InstanceType<typeof CustomListForm> | null>(null)

const formView = ref<Raw<CreateCustomListForm>>(
  new CreateCustomListForm(props.view),
)

// The parent replaces `view` when its doc changes (e.g. if you navigate to a
// different guide while you're in the reading view). Recreate the custom list
// form so that creating a custom list here will get that new doc.
watch(
  () => props.view,
  (view) => {
    formView.value = new CreateCustomListForm(view)
  },
)

async function show(): Promise<void> {
  if (!basePopup.value) {
    return
  }

  if (props.newStyle20321B) {
    // Wait for the list data to load so that the popup opens at its final
    // size. Once it does, we use that size to position it next to `anchor`.
    await props.view.getLists()
    basePopup.value?.show()
    return
  }

  basePopup.value.show()
  await props.view.getLists()
}

/**
 * Show the "Create New List" popup and hide this one.
 */
function showCreateList(): void {
  basePopup.value?.hide()
  customListForm.value?.show()
}

onBeforeUnmount(async () => {
  await props.view.clearState()
})

__expose({
  show,
})

return (_ctx: any,_cache: any) => {
  const _component_v_wait = _resolveComponent("v-wait")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(BasePopup, {
      ref_key: "basePopup",
      ref: basePopup,
      title: __props.newStyle20321B ? 'Save to:' : 'Add to...',
      class: _normalizeClass(["add-to-list", { 'add-to-list--20321B': __props.newStyle20321B }]),
      compact: !__props.newStyle20321B,
      menu: __props.newStyle20321B,
      anchor: __props.anchor,
      onHide: _cache[2] || (_cache[2] = ($event: any) => (__props.view.clearState()))
    }, _createSlots({
      default: _withCtx(() => [
        _createVNode(_component_v_wait, { for: "Error Loading Lists" }, {
          waiting: _withCtx(() => [
            _createVNode(LoadingError, { class: "add-to-list__error" })
          ]),
          _: 1
        }),
        _createVNode(_component_v_wait, { for: "Loading Lists" }, {
          waiting: _withCtx(() => [
            _createVNode(CircleSpinner, {
              class: "add-to-list__spinner",
              color: "#ffc906",
              size: 36
            })
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.view.lists, (list) => {
                return (_openBlock(), _createElementBlock(_Fragment, {
                  key: list.id
                }, [
                  _createVNode(ToggleButton, {
                    type: "checkbox",
                    variant: __props.newStyle20321B ? 'menu' : undefined,
                    class: "add-to-list__input",
                    value: __props.view.listsState[list.url_slug],
                    "onUpdate:value": 
              (updatedValue) =>
                __props.newStyle20321B
                  ? __props.view.toggleDestination(list, updatedValue)
                  : __props.view.toggleList(list, updatedValue)
            
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(list.title), 1)
                    ]),
                    _: 2
                  }, 1032, ["variant", "value", "onUpdate:value"]),
                  (__props.newStyle20321B && _unref(isWantToRead)(list))
                    ? (_openBlock(), _createBlock(ToggleButton, {
                        key: 0,
                        type: "checkbox",
                        variant: "menu",
                        class: "add-to-list__input",
                        value: __props.view.doc.user.is_favorite,
                        "onUpdate:value": _cache[0] || (_cache[0] = 
              (checked) => __props.view.toggleDestination('favorites', checked)
            )
                      }, {
                        default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                          _createTextVNode(" Favorites ", -1)
                        ]))]),
                        _: 1
                      }, 8, ["value"]))
                    : _createCommentVNode("", true)
                ], 64))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_2, [
              (!__props.newStyle20321B)
                ? (_openBlock(), _createBlock(AppButton, {
                    key: 0,
                    class: "add-to-list__btn add-to-list__btn--new",
                    icon: "iadd",
                    outlined: true,
                    onClick: showCreateList
                  }, {
                    default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                      _createTextVNode("New List", -1)
                    ]))]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(AppButton, {
                class: "add-to-list__btn add-to-list__btn--done",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (basePopup.value?.hide()))
              }, {
                default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                  _createTextVNode("Done", -1)
                ]))]),
                _: 1
              })
            ])
          ]),
          _: 1
        })
      ]),
      _: 2
    }, [
      (__props.newStyle20321B)
        ? {
            name: "headerAction",
            fn: _withCtx(() => [
              _createVNode(AppButton, {
                class: "add-to-list__btn add-to-list__btn--new",
                icon: "iadd",
                small: true,
                outlined: true,
                onClick: showCreateList
              }, {
                default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                  _createTextVNode("New List", -1)
                ]))]),
                _: 1
              })
            ]),
            key: "0"
          }
        : undefined
    ]), 1032, ["title", "class", "compact", "menu", "anchor"]),
    _createVNode(CustomListForm, {
      ref_key: "customListForm",
      ref: customListForm,
      view: formView.value
    }, null, 8, ["view"])
  ], 64))
}
}

})